(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("JSONFormsCore"), require("JSONFormsAngular"));
	else if(typeof define === 'function' && define.amd)
		define("JSONFormsIonic", ["JSONFormsCore", "JSONFormsAngular"], factory);
	else if(typeof exports === 'object')
		exports["JSONFormsIonic"] = factory(require("JSONFormsCore"), require("JSONFormsAngular"));
	else
		root["JSONFormsIonic"] = factory(root["JSONFormsCore"], root["JSONFormsAngular"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__28__) {
return 